import React from "react";
import Item from "./Item";
import { useState } from "react";
const MenuList = ({ items, setPagePath, setRoutes }) => {
  // const [isOpened, setIsOpened] = useState(false);
  // console.log(items)
  const [selectedLvl1, setSelectedLvl1] = useState(null);
  return (
    <div className="wrapper">
      {/* <h3>SIDEBAR</h3> */}
      {items.map((item) => (
        <div>
          <Item
            selectedLvl1={selectedLvl1}
            setSelectedLvl1={setSelectedLvl1}
            item={item}
            setPagePath={setPagePath}
            setRoutes={setRoutes}
          />
        </div>
      ))}
    </div>
  );
};

export default MenuList;
